import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FiUsers, FiActivity, FiShield } from 'react-icons/fi'
import './authLayout.css'

const HIGHLIGHTS = [
  { icon: <FiUsers size={16} />, text: 'Copy experienced traders automatically' },
  { icon: <FiActivity size={16} />, text: 'Track every mirrored trade in real time' },
  { icon: <FiShield size={16} />, text: 'Secure your account with two-factor authentication' },
]

// Split-screen shell for the auth pages: brand story on the left, form on the right
const AuthLayout = ({ heading, subheading, children }) => {
  const navigate = useNavigate()

  return (
    <main className="auth-page">
      <aside className="auth-brand">
        <img
          src="/ollarinmirror-logo.svg"
          alt="Ollarin Mirror"
          className="auth-brand-logo"
          onClick={() => navigate('/')}
        />
        <div className="auth-brand-body">
          <h1 className="auth-brand-heading">
            Expert-managed trading,<br />
            <span>while you grow with confidence.</span>
          </h1>
          <div className="auth-brand-rule" />
          <ul className="auth-highlights">
            {HIGHLIGHTS.map(item => (
              <li key={item.text}>
                <span className="auth-highlight-icon">{item.icon}</span>
                {item.text}
              </li>
            ))}
          </ul>
        </div>
        <p className="auth-brand-footer">© {new Date().getFullYear()} Ollarin Mirror</p>
      </aside>

      <section className="auth-panel">
        <div className="auth-panel-inner">
          <img
            src="/ollarinmirror-logo.svg"
            alt="Ollarin Mirror"
            className="auth-mobile-logo"
            onClick={() => navigate('/')}
          />
          <div className="auth-panel-header">
            <h2>{heading}</h2>
            {subheading && <p>{subheading}</p>}
          </div>
          {children}
        </div>
      </section>
    </main>
  )
}

export default AuthLayout
